"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUniqueIdForNavbarLink = generateUniqueIdForNavbarLink;
exports.linkWithChildrenPropsToLinkProps = linkWithChildrenPropsToLinkProps;
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const StringHelper_1 = require("../objects/StringHelper");
function externalLinkPropToLinkProps(link) {
    return {
        id: link.id,
        linkType: link.linkType,
        linkLabel: link.id,
        url: link.url,
        openInNewTab: link.target === graphql_schema_types_1.LinkTarget.Blank
    };
}
function internalLinkPropToLinkProps(link) {
    return {
        id: link.id,
        linkType: link.linkType,
        linkLabel: link.id,
        goesToPage: {
            route: link.routeName,
            params: link.params
        }
    };
}
function linkPropToLinkProps(link) {
    switch (link.linkType) {
        case graphql_schema_types_1.LinkType.External: {
            return externalLinkPropToLinkProps(link);
        }
        case graphql_schema_types_1.LinkType.Internal: {
            return internalLinkPropToLinkProps(link);
        }
        default: {
            return null;
        }
    }
}
/**
 * Creates a unique ID for a navbar link across all links in the navbar.
 *
 * @param mainList the main list of links
 * @param sideList the side list of links
 * @param logoList the logo list of links
 * @param value the desired ID value for the link
 * @param quiltWrapperId the ID of the quilt wrapper
 */
function generateUniqueIdForNavbarLink(mainList, sideList, logoList, value, quiltWrapperId) {
    const newId = `${quiltWrapperId}-${(0, StringHelper_1.hyphenCase)(value)}-link`;
    const ids = [
        ...mainList.map(({ id }) => id),
        ...sideList.map(({ id }) => id),
        ...logoList.map(({ id }) => id)
    ];
    mainList.forEach(({ children }) => children === null || children === void 0 ? void 0 : children.forEach(({ id }) => ids.push(id)));
    sideList.forEach(({ children }) => children === null || children === void 0 ? void 0 : children.forEach(({ id }) => ids.push(id)));
    logoList.forEach(({ children }) => children === null || children === void 0 ? void 0 : children.forEach(({ id }) => ids.push(id)));
    if (!ids.includes(newId)) {
        return newId;
    }
    const suffixIdRegex = new RegExp('.*-(\\d+)$');
    const maxCount = ids
        .filter(id => id.startsWith(newId))
        .map(id => {
        const match = id.match(suffixIdRegex);
        return match ? Number.parseInt(match[1]) : 0;
    })
        .sort()
        .at(-1);
    return `${newId}-${maxCount + 1}`;
}
/**
 * Converts the format returned by the query to the format used for the Navbar Link Builder
 * @param links
 */
function linkWithChildrenPropsToLinkProps(links) {
    if (!links) {
        return [];
    }
    return links
        .map(link => {
        if (link.linkType === graphql_schema_types_1.LinkType.External) {
            return Object.assign(Object.assign({}, externalLinkPropToLinkProps(link)), { children: link.children ? link.children.map(child => linkPropToLinkProps(child)) : null });
        }
        else if (link.linkType === graphql_schema_types_1.LinkType.Internal) {
            const internalLink = internalLinkPropToLinkProps(link);
            return internalLink
                ? Object.assign(Object.assign({}, internalLink), { children: link.children
                        ? link.children.map(child => linkPropToLinkProps(child))
                        : null }) : null;
        }
        return null;
    })
        .filter(l => !!l);
}
//# sourceMappingURL=NavbarLinkPropsHelper.js.map